import { render } from "./SimplificationOfWork.vue?vue&type=template&id=a910144a&scoped=true"
import script from "./SimplificationOfWork.vue?vue&type=script&lang=js"
export * from "./SimplificationOfWork.vue?vue&type=script&lang=js"

import "./SimplificationOfWork.vue?vue&type=style&index=0&id=a910144a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a910144a"]])

export default __exports__